import get from 'lodash/get';
import { createWithEqualityFn } from 'zustand/traditional';

export const ImageKey = {
  recommendImages: 'recommendImages',
  allImages: 'allImages',
  hotImages: 'hotImages',
};

export const useModels = createWithEqualityFn(() => ({
  // 全部图片案例数据
  [ImageKey.allImages]: {
    // 目前全量数据和推荐数据用的同一份入参，唯一区别就是是否有filters.prompt过滤
    tags: [],
    filters: {
      tag: null,
      prompt: '',
      page: 1,
      pageSize: 200,
    },
    data: { items: [], loading: false, hasMore: false, total: 0 },
  },
  // 推荐图片案例数据
  [ImageKey.recommendImages]: {
    tags: [],
    filters: {
      tag: null,
      prompt: '',
      page: 1,
      pageSize: 200,
    },
    data: { items: [], loading: false, hasMore: false, total: 0 },
  },
  // 热门图片案例数据
  [ImageKey.hotImages]: {
    tags: [],
    filters: {
      tag: null,
      prompt: '',
      page: 1,
      pageSize: 200,
    },
    data: { items: [], loading: false, hasMore: false, total: 0 },
  },
  modelImages: {
    modelData: null,
    case: {
      filters: { versionUuid: null, page: 1, pageSize: 30 },
      data: { items: [], loading: false, hasMore: false, total: 0 },
    },
    more: {
      filters: {
        versionUuid: null,
        page: 1,
        pageSize: 30,
      },
      data: { items: [], loading: false, hasMore: false, total: 0 },
    },
  },
}));

export const updatePartialState = (keyPath, partialState) => {
  const state = useModels.getState();
  const subState = get(state, keyPath);

  if (typeof partialState === 'function') {
    partialState = partialState(subState);
  }

  const nextState = { ...state };

  // 从底层往上层逐层更新每一层对象为新的引用，而不能直接修改原对象
  const keys = keyPath.split('.');

  keys.reduce((acc, key, index) => {
    if (index === keys.length - 1) {
      acc[key] = { ...subState, ...partialState };
    } else {
      acc[key] = { ...acc[key] };
    }

    return acc[key];
  }, nextState);

  useModels.setState(nextState);
};

export const getPartialState = (keyPath) => {
  return get(useModels.getState(), keyPath);
};

export const usePartialState = (keyPath) => {
  return useModels((state) => get(state, keyPath));
};
